import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "user",
  initialState: {
    userArray:{}
  },
  reducers: {
    loginMethod: (state, action) => {
  state.userArray =action.payload;
 },
 },
});

export const { loginMethod } = authSlice.actions;
export default authSlice.reducer;